import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import PrincipalHistorizationPreviewItemViewModelType from '@/ViewModels/Controls/PrincipalHistorizationPreviewItemViewModel';
import LabelType from '@/Controls/Label';
import ImageType from '@/Controls/Image';
import DateTimeLabelType from '@/Controls/DateTimeLabel';

export default class PrincipalHistorizationPreviewItem extends Control {

    private Label = ComponentManager.getControl<typeof LabelType>('Label');
    private Image = ComponentManager.getControl<typeof ImageType>('Image');
    private DateTimeLabel = ComponentManager.getControl<typeof DateTimeLabelType>('DateTimeLabel');
    private jQueryControl: JQuery;
    private label: LabelType;
    private image: ImageType;
    private datetimelabel: DateTimeLabelType;

    public constructor(private viewModel: PrincipalHistorizationPreviewItemViewModelType, private element?: JQuery) {
        super(viewModel, element);
        
        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<li>');

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'principalhistorizationpreviewitem',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            invalid: this.viewModel.invalidationText,

            visible: this.viewModel.isVisible,

            styles: this.definePureComputed({
                read: () => {
                    let styles = [];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });

        if (this.viewModel.image != null) {
            this.image = new this.Image(this.viewModel.image);
            let tuple = this.image.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }

        if (this.viewModel.label != null) {
            this.label = new this.Label(this.viewModel.label);
            let tuple = this.label.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }

        if (this.viewModel.datetimelabel != null) {
            this.datetimelabel = new this.DateTimeLabel(this.viewModel.datetimelabel);
            let tuple = this.datetimelabel.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }
    }
}

ComponentManager.setControl('PrincipalHistorizationPreviewItem', PrincipalHistorizationPreviewItem, 'RADPresentation.HTMLClient.DefaultViewExtensions');